// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReferralForm_formContainer__UaU1Y {
  border: 1px solid #D9D9D9;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  padding: 24px;
  background-color: #FFFFFF;
  border-radius: 20px;
  max-width: 420px;
}

.ReferralForm_formTitle__xKY\\+g {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 24px;
  line-height: 1.4;
  text-align: center;
}

.ReferralForm_highlight__uN2Hu {
  color: #A16B00;
}

.ReferralForm_fieldGroup__hOxIB {
  margin-bottom: 20px;
}

.ReferralForm_label__F0Pl2 {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 8px;
}

.ReferralForm_required__eRTWh {
  color: #FF0000;
  margin-left: 2px;
}

.ReferralForm_textField__dhenw .MuiOutlinedInput-root {
  border-radius: 8px;
}

.ReferralForm_textField__dhenw .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: #E0E0E0;
}

.ReferralForm_textField__dhenw .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #BDBDBD;
}

.ReferralForm_textField__dhenw .Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #FFC107;
}

.ReferralForm_textField__dhenw .MuiInputBase-input {
  padding: 12px 16px;
  font-size: 14px;
  color: #333333;
}

.ReferralForm_textField__dhenw .MuiInputBase-input::placeholder {
  color: #9E9E9E;
  opacity: 1;
}

.ReferralForm_phoneInputWrapper__oFDvQ {
  position: relative;
}

.ReferralForm_phonePlaceholder__5drls {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 82px;
  color: #9E9E9E;
  font-size: 14px;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.ReferralForm_phoneContainer__wUnR7 {
  width: 100%;
}

.ReferralForm_phoneContainer__wUnR7 .react-tel-input {
  width: 100%;
}

.ReferralForm_phoneInput__4qg6l {
  width: 100% !important;
  height: 44px !important;
  font-size: 14px !important;
  border-radius: 8px !important;
  border: 1px solid #E0E0E0 !important;
  padding-left: 52px !important;
  color: #333333 !important;
}

.ReferralForm_phoneInput__4qg6l:hover {
  border-color: #BDBDBD !important;
}

.ReferralForm_phoneInput__4qg6l:focus {
  border-color: #FFC107 !important;
  box-shadow: none !important;
}

.ReferralForm_phoneInput__4qg6l::placeholder {
  color: #9E9E9E !important;
}

.ReferralForm_phoneButton__nU\\+lK {
  border: 1px solid #E0E0E0 !important;
  border-radius: 8px 0 0 8px !important;
  background-color: #FFFFFF !important;
}

.ReferralForm_phoneButton__nU\\+lK:hover {
  background-color: #F5F5F5 !important;
}

.ReferralForm_submitButton__UnmR- {
  width: 100%;
  background-color: #FFC62E;
  color: #614600;
  font-size: 16px;
  font-weight: 600;
  border: 2px solid #FFE294;
  border-radius: 12px;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.2s ease;
  padding: 12px;
}

.ReferralForm_submitButton__UnmR-:hover {
  background-color: #FFD666;
  transform: translateY(-1px);
  box-shadow: 0px 4px 12px rgba(255, 193, 7, 0.3);
}

.ReferralForm_submitButton__UnmR-:active {
  transform: translateY(0px);
}

.ReferralForm_submitButton__UnmR-:disabled {
  background-color: #E0E0E0;
  color: #9E9E9E;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.ReferralForm_referralDividerContainer__E4mXA {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

.ReferralForm_referralDivider__7dpy6 {
  flex: 1 1;
  height: 1px;
  background-color: #E6E6E6;
}

.ReferralForm_referralDividerText__hlbBv {
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -3%;
  color: #999999;
}

@media (max-width: 480px) {
  .ReferralForm_formContainer__UaU1Y {
    padding: 20px;
    max-width: 100%;

  }

  .ReferralForm_formTitle__xKY\\+g {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .ReferralForm_submitButton__UnmR- {
    font-size: 14px;
  }
}

@media (min-width: 481px) and (max-width: 1024px) {
  .ReferralForm_formContainer__UaU1Y {
    max-width: 480px;
    padding: 24px;
    align-self: center;
    width: 480px;
  }
}`, "",{"version":3,"sources":["webpack://./src/CheckoutPage/ReferralForm/index.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,eAAe;;EAEjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;AACF","sourcesContent":[".formContainer {\n  border: 1px solid #D9D9D9;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);\n  padding: 24px;\n  background-color: #FFFFFF;\n  border-radius: 20px;\n  max-width: 420px;\n}\n\n.formTitle {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 24px;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.highlight {\n  color: #A16B00;\n}\n\n.fieldGroup {\n  margin-bottom: 20px;\n}\n\n.label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333333;\n  margin-bottom: 8px;\n}\n\n.required {\n  color: #FF0000;\n  margin-left: 2px;\n}\n\n.textField :global(.MuiOutlinedInput-root) {\n  border-radius: 8px;\n}\n\n.textField :global(.MuiOutlinedInput-root) :global(.MuiOutlinedInput-notchedOutline) {\n  border-color: #E0E0E0;\n}\n\n.textField :global(.MuiOutlinedInput-root):hover :global(.MuiOutlinedInput-notchedOutline) {\n  border-color: #BDBDBD;\n}\n\n.textField :global(.Mui-focused) :global(.MuiOutlinedInput-notchedOutline) {\n  border-color: #FFC107;\n}\n\n.textField :global(.MuiInputBase-input) {\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #333333;\n}\n\n.textField :global(.MuiInputBase-input)::placeholder {\n  color: #9E9E9E;\n  opacity: 1;\n}\n\n.phoneInputWrapper {\n  position: relative;\n}\n\n.phonePlaceholder {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 82px;\n  color: #9E9E9E;\n  font-size: 14px;\n  pointer-events: none;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.phoneContainer {\n  width: 100%;\n}\n\n.phoneContainer :global(.react-tel-input) {\n  width: 100%;\n}\n\n.phoneInput {\n  width: 100% !important;\n  height: 44px !important;\n  font-size: 14px !important;\n  border-radius: 8px !important;\n  border: 1px solid #E0E0E0 !important;\n  padding-left: 52px !important;\n  color: #333333 !important;\n}\n\n.phoneInput:hover {\n  border-color: #BDBDBD !important;\n}\n\n.phoneInput:focus {\n  border-color: #FFC107 !important;\n  box-shadow: none !important;\n}\n\n.phoneInput::placeholder {\n  color: #9E9E9E !important;\n}\n\n.phoneButton {\n  border: 1px solid #E0E0E0 !important;\n  border-radius: 8px 0 0 8px !important;\n  background-color: #FFFFFF !important;\n}\n\n.phoneButton:hover {\n  background-color: #F5F5F5 !important;\n}\n\n.submitButton {\n  width: 100%;\n  background-color: #FFC62E;\n  color: #614600;\n  font-size: 16px;\n  font-weight: 600;\n  border: 2px solid #FFE294;\n  border-radius: 12px;\n  cursor: pointer;\n  margin-top: 8px;\n  transition: all 0.2s ease;\n  padding: 12px;\n}\n\n.submitButton:hover {\n  background-color: #FFD666;\n  transform: translateY(-1px);\n  box-shadow: 0px 4px 12px rgba(255, 193, 7, 0.3);\n}\n\n.submitButton:active {\n  transform: translateY(0px);\n}\n\n.submitButton:disabled {\n  background-color: #E0E0E0;\n  color: #9E9E9E;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.referralDividerContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.referralDivider {\n  flex: 1;\n  height: 1px;\n  background-color: #E6E6E6;\n}\n\n.referralDividerText {\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -3%;\n  color: #999999;\n}\n\n@media (max-width: 480px) {\n  .formContainer {\n    padding: 20px;\n    max-width: 100%;\n\n  }\n\n  .formTitle {\n    font-size: 16px;\n    margin-bottom: 16px;\n  }\n\n  .submitButton {\n    font-size: 14px;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 1024px) {\n  .formContainer {\n    max-width: 480px;\n    padding: 24px;\n    align-self: center;\n    width: 480px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `ReferralForm_formContainer__UaU1Y`,
	"formTitle": `ReferralForm_formTitle__xKY+g`,
	"highlight": `ReferralForm_highlight__uN2Hu`,
	"fieldGroup": `ReferralForm_fieldGroup__hOxIB`,
	"label": `ReferralForm_label__F0Pl2`,
	"required": `ReferralForm_required__eRTWh`,
	"textField": `ReferralForm_textField__dhenw`,
	"phoneInputWrapper": `ReferralForm_phoneInputWrapper__oFDvQ`,
	"phonePlaceholder": `ReferralForm_phonePlaceholder__5drls`,
	"phoneContainer": `ReferralForm_phoneContainer__wUnR7`,
	"phoneInput": `ReferralForm_phoneInput__4qg6l`,
	"phoneButton": `ReferralForm_phoneButton__nU+lK`,
	"submitButton": `ReferralForm_submitButton__UnmR-`,
	"referralDividerContainer": `ReferralForm_referralDividerContainer__E4mXA`,
	"referralDivider": `ReferralForm_referralDivider__7dpy6`,
	"referralDividerText": `ReferralForm_referralDividerText__hlbBv`
};
export default ___CSS_LOADER_EXPORT___;
